import { defineStore } from 'pinia';
import { ref, UnwrapRef, watch } from 'vue';

import { safeJsonParse } from '../json';
export function createFilterStore<T>(getDefaultFilter: () => T) {
  return defineStore('filter', () => {
    const filter = ref<T>(getDefaultFilter());
    if (sessionStorage.getItem('filter')) {
      const parsedFilter = safeJsonParse<T>(sessionStorage.getItem('filter') as string);
      filter.value = parsedFilter as UnwrapRef<T>;
    }
    watch(filter, (filter) => {
      const filterEncoded = JSON.stringify(filter);
      if (filterEncoded !== sessionStorage.getItem('filter')) {
        sessionStorage.setItem('filter', filterEncoded);
      }
    });
    return {
      filter,
    };
  });
}
